//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    zone: Object,
    isHiddenMobile: {
      type: Boolean,
      default: false
    }
  }
}

